export const SET_JENSEKS = (state, payload) => {
    state.jensekData = payload;
}

export const SET_JEGURS = (state, jegur) => {
    state.jegurData = jegur;
}

export const SET_JEGURS_ALL = (state, jegur) => {
    state.jegurDataAll = jegur;
}

export const SET_JENDIKS = (state, payload) => {
    state.jendikData = payload;
}

export const SET_MAPELS = (state, payload) => {
    state.mapelData = payload;
}

export const SET_KECAMS = (state, payload) => {
    state.kecamData = payload;
}

export const SET_KELURS = (state, payload) => {
    state.kelurData = payload;
}

export const SET_PAONES = (state, payload) => {
    state.paoneData = payload;
}

export const SET_PATWOS = (state, payload) => {
    state.patwoData = payload;
}

export const SET_TAJARS = (state, payload) => {
    state.tajarData = payload;
}

export const SET_TAJAR_AKTIF = (state, payload) => {
    state.tajarAktif = payload;
}

export const SET_TAJARS_NON_AKTIF = (state, payload) => {
    state.tajarsNonAktif = payload;
}

export const SET_EDUS = (state, payload) => {
    state.eduData = payload;
}

export const SET_TUTAMS = (state, payload) => {
    let no_kepsek = payload.filter(x => x.val != 1);
    state.tutamData = no_kepsek;
}

export const SET_ALARS = (state, payload) => {
    state.alarData = payload;
}

export const SET_AGAMAS = (state, payload) => {
    state.agamaData = payload;
}

export const SET_STAPEGS = (state, payload) => {
    state.stapegData = payload;
}

export const SET_BERKAS = (state, payload) => {
    state.berkasData = payload;
}

export const SET_KONTAK = (state, payload) => {
    state.kontakData = payload;
}